import { render } from "./Card.vue?vue&type=template&id=1aa1fbcc&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1aa1fbcc"

export default script